import { Divider,  Stack, Typography } from "@mui/material";
import React from "react";
import VWLogo from "../assets/volkswagon_logo.svg";
import { Logout } from "@mui/icons-material";

const Header = ({ handleLogout,setCurrentTab, showUnsavedPopup,
  setShowUnsavedPopup,
  hasUnsavedChanges,
  setHasUnsavedChanges, }) => {
  
  const handleLogoClick = () =>{
   if(hasUnsavedChanges) {
    setShowUnsavedPopup(true);
    
   }else{
    setCurrentTab(null)
   }
  }

  return (
    <div className="header_main">
      <div className="header_inner">
        <Stack direction={"row"} gap={2}>
          <Typography className="shakun_motors" onClick={handleLogoClick}>Shakun Motors</Typography>
          <Divider className="header_divider" orientation="vertical"/>
          <img src={VWLogo} />
        </Stack>
       {localStorage.getItem("token") ? <Logout onClick={handleLogout} /> : <div></div> }
        
      </div>
    </div>
  );
};

export default Header;
